export interface SecondaryCategoryConfigConstructor {
  id: number
  name: string
  externalId: Nullable<string>
  punchoutEmail: Nullable<string>
}

export class SecondaryCategoryConfig {
  readonly id: number
  readonly name: string
  readonly externalId: Nullable<string>
  readonly punchoutEmail: Nullable<string>

  constructor(data: SecondaryCategoryConfigConstructor) {
    this.id = data.id
    this.name = data.name
    this.externalId = data.externalId
    this.punchoutEmail = data.punchoutEmail
  }

  get hasExternalId(): boolean {
    return !!this.externalId
  }

  get hasPunchoutEmail(): boolean {
    return !!this.punchoutEmail
  }
}
